import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Typography } from "antd";
import { 
	getJobRoleDetails
} from "../../../../redux/jobrole/jobRoleState";
import Card from "components/card";



const JobRoleDetails = ({ recordData, getRecord, ...props }) => {
    const {  Paragraph, Text } = Typography;
    const { recordId } = props;

	useEffect(() => {
		if (recordId) {
			getRecord(recordId);
		}
	}, [recordId, getRecord]);

	return (
        <Card className="p-10 shadow-sm border border-gray-200 bg-white">
            <Paragraph className="text-sm label-title !mb-0">
                <Text strong>Job Title:</Text>{" "} 
                {recordData?.jro_job_title}
            </Paragraph>
            <Paragraph className="text-sm label-title !mb-0">
                <Text strong>Count:</Text>{" "}
                {recordData?.jro_count}
            </Paragraph>
            <Paragraph className="text-sm label-title">
                <Text strong>Location:</Text>{" "}
                {recordData?.jro_location}
            </Paragraph>
            
            <Paragraph className="text-sm label-title">
                 <Text strong>Job Description:</Text>{" "}
                {recordData?.jro_job_description}
            </Paragraph>

            {Array.isArray(recordData?.jro_key_responsibilities) &&
                recordData.jro_key_responsibilities.length > 0 && (
                    <>
                        <Text strong>Key Responsibilities:</Text>{" "}
                        <ul className="list-disc pl-8 space-y-2 text-sm label-title mt-2 mb-4">
                            {recordData.jro_key_responsibilities.map((item, index) => (
                            <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </>
                )}

            {Array.isArray(recordData?.jro_preferred_qualifications) &&
                recordData.jro_preferred_qualifications.length > 0 && (
                    <>
                        <Text strong>Preffered Qualifications:</Text>{" "}
                        <ul className="list-disc pl-8 space-y-2 text-sm label-title mt-2 mb-4">
                            {recordData.jro_preferred_qualifications.map((item, index) => (
                            <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </>
                )}
            
            <Paragraph className="text-sm label-title ">
                {recordData?.jro_add_info}
            </Paragraph>

            {recordData?.jro_how_to_apply && (
                <>
                    <Text strong>How to Apply:</Text>{" "}
                    <Paragraph className="text-sm label-title mt-2">
                        {recordData.jro_how_to_apply}
                    </Paragraph>
                </>
            )}
        </Card>
	);
};

const mapStateToProps = (state) => ({
	recordData: state.jobRole.jobRoleDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getJobRoleDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobRoleDetails);